<template>
    <div class="page-wrapper">
        <h3 class="tit">葛家车智造园</h3>
        <div class="top-btns">
            <el-button class="r-btn" type="primary" icon="el-icon-edit" size="medium" @click="editHandle" :disabled="!uneditable">编辑表单</el-button>
            <br>
            <el-button class="r-btn" type="success" icon="el-icon-link" size="medium" @click="linkToDataV">查看大屏</el-button>
            <br>
            <el-button class="r-btn" type="warning" icon="el-icon-circle-check" size="medium" @click="takeEffectAtOnce">立即生效</el-button>
            <br>
            <el-button class="r-btn" type="info" icon="el-icon-top" size="medium" @click="toPageTop">回到顶部</el-button>
        </div>
        
        <div class="datav-form-wrapper">
            <el-form class="c-form" :model="editForm" ref="editForm" label-position="top">
                <el-form-item class="c-form-item" label="在职工人数">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-gejiachecun/001.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-gejiachecun/001.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        在职工人数 = 最小值和最大值之间的随机数
                    </p>
                    <el-form-item class="c-form-item-inner" label="人数范围" required>
                        <el-col :span="6">
                            <el-form-item
                                prop="factoryStaffNumer.min"
                                :rules="[
                                    { required: true, message: '请输入最小值（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.factoryStaffNumer.min=switchToInt(editForm.factoryStaffNumer.min, 'unsigned');switchObjMaxAndMin(editForm.factoryStaffNumer)"
                                    v-model="editForm.factoryStaffNumer.min"
                                    placeholder="请输入最小值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="factoryStaffNumer.max"
                                :rules="[
                                    { required: true, message: '请输入最大值（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.factoryStaffNumer.max=switchToInt(editForm.factoryStaffNumer.max, 'unsigned');switchObjMaxAndMin(editForm.factoryStaffNumer)"
                                    v-model="editForm.factoryStaffNumer.max"
                                    placeholder="请输入最大值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="出勤人数">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-gejiachecun/002.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-gejiachecun/002.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        在职工人数 = 最小值和最大值之间的随机数
                    </p>
                    <el-form-item class="c-form-item-inner" label="人数范围" required>
                        <el-col :span="6">
                            <el-form-item
                                prop="attendanceStaffNumber.min"
                                :rules="[
                                    { required: true, message: '请输入最小值（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.attendanceStaffNumber.min=switchToInt(editForm.attendanceStaffNumber.min, 'unsigned');switchObjMaxAndMin(editForm.attendanceStaffNumber)"
                                    v-model="editForm.attendanceStaffNumber.min"
                                    placeholder="请输入最小值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="attendanceStaffNumber.max"
                                :rules="[
                                    { required: true, message: '请输入最大值（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.attendanceStaffNumber.max=switchToInt(editForm.attendanceStaffNumber.max, 'unsigned');switchObjMaxAndMin(editForm.attendanceStaffNumber)"
                                    v-model="editForm.attendanceStaffNumber.max"
                                    placeholder="请输入最大值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="工厂面积">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-gejiachecun/003.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-gejiachecun/003.png">
                        </div>
                    </el-popover>
                    <el-form-item class="c-form-item-inner" label="配置数据"
                        prop="factoryArea.radix"
                        :rules="[
                            { required: true, message: '请输入配置数据（正整数）', trigger: 'blur' }
                        ]"
                    >
                        <el-input
                            @blur="editForm.factoryArea.radix=switchToInt(editForm.factoryArea.radix, 'unsigned')"
                            class="w"
                            v-model="editForm.factoryArea.radix"
                            placeholder="请输入配置数据"
                            :disabled="uneditable"
                        ></el-input>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="工厂数量">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-gejiachecun/004.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-gejiachecun/004.png">
                        </div>
                    </el-popover>
                    <el-form-item class="c-form-item-inner" label="配置数据"
                        prop="factoryNumber.radix"
                        :rules="[
                            { required: true, message: '请输入配置数据（正整数）', trigger: 'blur' }
                        ]"
                    >
                        <el-input
                            @blur="editForm.factoryNumber.radix=switchToInt(editForm.factoryNumber.radix, 'unsigned')"
                            class="w"
                            v-model="editForm.factoryNumber.radix"
                            placeholder="请输入配置数据"
                            :disabled="uneditable"
                        ></el-input>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="设备数量">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-gejiachecun/005.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-gejiachecun/005.png">
                        </div>
                    </el-popover>
                    <el-form-item class="c-form-item-inner" label="配置数据"
                        prop="equipmentNumber.radix"
                        :rules="[
                            { required: true, message: '请输入配置数据（正整数）', trigger: 'blur' }
                        ]"
                    >
                        <el-input
                            @blur="editForm.equipmentNumber.radix=switchToInt(editForm.equipmentNumber.radix, 'unsigned')"
                            class="w"
                            v-model="editForm.equipmentNumber.radix"
                            placeholder="请输入配置数据"
                            :disabled="uneditable"
                        ></el-input>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="共享设备数量">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-gejiachecun/006.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-gejiachecun/006.png">
                        </div>
                    </el-popover>
                    <el-form-item class="c-form-item-inner" label="配置数据"
                        prop="shareEquipmentNumber.radix"
                        :rules="[
                            { required: true, message: '请输入配置数据（正整数）', trigger: 'blur' }
                        ]"
                    >
                        <el-input
                            @blur="editForm.shareEquipmentNumber.radix=switchToInt(editForm.shareEquipmentNumber.radix, 'unsigned')"
                            class="w"
                            v-model="editForm.shareEquipmentNumber.radix"
                            placeholder="请输入配置数据"
                            :disabled="uneditable"
                        ></el-input>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="当月面料供应单量">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-gejiachecun/007.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-gejiachecun/007.png">
                        </div>
                    </el-popover>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="数量（单）"
                                prop="monthFabricSupply.number"
                                :rules="[
                                    { required: true, message: '请输入数量（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.monthFabricSupply.number=switchToInt(editForm.monthFabricSupply.number, 'unsigned')"
                                    v-model="editForm.monthFabricSupply.number"
                                    placeholder="请输入数量"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="金额（元）"
                                prop="monthFabricSupply.money"
                                :rules="[
                                    { required: true, message: '请输入金额（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.monthFabricSupply.money=switchToInt(editForm.monthFabricSupply.money, 'unsigned')"
                                    v-model="editForm.monthFabricSupply.money"
                                    placeholder="请输入金额"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form-item>

                <el-form-item class="c-form-item" label="当月辅料供应单量">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-gejiachecun/008.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-gejiachecun/008.png">
                        </div>
                    </el-popover>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="数量（单）"
                                prop="monthAccessoriesSupply.number"
                                :rules="[
                                    { required: true, message: '请输入数量（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.monthAccessoriesSupply.number=switchToInt(editForm.monthAccessoriesSupply.number, 'unsigned')"
                                    v-model="editForm.monthAccessoriesSupply.number"
                                    placeholder="请输入数量"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="金额（元）"
                                prop="monthAccessoriesSupply.money"
                                :rules="[
                                    { required: true, message: '请输入金额（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.monthAccessoriesSupply.money=switchToInt(editForm.monthAccessoriesSupply.money, 'unsigned')"
                                    v-model="editForm.monthAccessoriesSupply.money"
                                    placeholder="请输入金额"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form-item>

                <el-form-item class="c-form-item" label="外部工厂对接数">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-gejiachecun/009.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-gejiachecun/009.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        外部工厂对接数 = 固定基数基础上，每月递增最小值和最大值之间的随机数
                    </p>
                    <el-form-item class="c-form-item-inner" label="固定基数"
                        prop="externalFactoryNumber.radix"
                        :rules="[
                            { required: true, message: '请输入固定基数（整数）', trigger: 'blur' }
                        ]"
                    >
                        <el-input
                            @blur="editForm.externalFactoryNumber.radix=switchToInt(editForm.externalFactoryNumber.radix)"
                            class="w"
                            v-model="editForm.externalFactoryNumber.radix"
                            placeholder="请输入固定基数"
                            :disabled="uneditable"
                        ></el-input>
                    </el-form-item>
                    <el-form-item class="c-form-item-inner" label="每月递增范围" required>
                        <el-col :span="6">
                            <el-form-item
                                prop="externalFactoryNumber.min"
                                :rules="[
                                    { required: true, message: '请输入最小值（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.externalFactoryNumber.min=switchToInt(editForm.externalFactoryNumber.min, 'unsigned');switchObjMaxAndMin(editForm.externalFactoryNumber)"
                                    v-model="editForm.externalFactoryNumber.min"
                                    placeholder="请输入最小值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="externalFactoryNumber.max"
                                :rules="[
                                    { required: true, message: '请输入最大值（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.externalFactoryNumber.max=switchToInt(editForm.externalFactoryNumber.max, 'unsigned');switchObjMaxAndMin(editForm.externalFactoryNumber)"
                                    v-model="editForm.externalFactoryNumber.max"
                                    placeholder="请输入最大值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="达标免租空间">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-gejiachecun/010.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-gejiachecun/010.png">
                        </div>
                    </el-popover>
                    <el-form-item class="c-form-item-inner" label="配置数据"
                        prop="standardsFreeSpace.radix"
                        :rules="[
                            { required: true, message: '请输入配置数据（正整数）', trigger: 'blur' }
                        ]"
                    >
                        <el-input
                            @blur="editForm.standardsFreeSpace.radix=switchToInt(editForm.standardsFreeSpace.radix, 'unsigned')"
                            class="w"
                            v-model="editForm.standardsFreeSpace.radix"
                            placeholder="请输入配置数据"
                            :disabled="uneditable"
                        ></el-input>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="累计免租额">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-gejiachecun/011.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-gejiachecun/011.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        累计免租额 = 达标免租空间 * 2 * 26 + 附加数据
                    </p>
                    <el-form-item class="c-form-item-inner" label="附加数据"
                        prop="totalFreeAmount.radix"
                        :rules="[
                            { required: true, message: '请输入附加数据（正整数）', trigger: 'blur' }
                        ]"
                    >
                        <el-input
                            @blur="editForm.totalFreeAmount.radix=switchToInt(editForm.totalFreeAmount.radix, 'unsigned')"
                            class="w"
                            v-model="editForm.totalFreeAmount.radix"
                            placeholder="请输入附加数据"
                            :disabled="uneditable"
                        ></el-input>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="当月成衣加工件数">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-gejiachecun/012.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-gejiachecun/012.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        当月成衣加工件数 = 最小值和最大值之间的数， 该数值有规律递增
                    </p>
                    <el-form-item class="c-form-item-inner" label="当月成衣加工件数（整数）" required>
                        <el-col :span="6">
                            <el-form-item
                                prop="monthClothesProductNumber.min"
                                :rules="[
                                    { required: true, message: '请输入最小值（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.monthClothesProductNumber.min=switchToInt(editForm.monthClothesProductNumber.min, 'unsigned');switchObjMaxAndMin(editForm.monthClothesProductNumber)"
                                    v-model="editForm.monthClothesProductNumber.min"
                                    placeholder="请输入最小值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="monthClothesProductNumber.max"
                                :rules="[
                                    { required: true, message: '请输入最大值（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.monthClothesProductNumber.max=switchToInt(editForm.monthClothesProductNumber.max, 'unsigned');switchObjMaxAndMin(editForm.monthClothesProductNumber)"
                                    v-model="editForm.monthClothesProductNumber.max"
                                    placeholder="请输入最大值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="今日完成订单数">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-gejiachecun/013.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-gejiachecun/013.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        今日完成订单数 = 最小值到最大值按时间有规律变化
                    </p>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="起始时间（小时， 0-24）"
                                prop="todayFinishedOrder.startTime"
                                :rules="[
                                    { required: true, message: '请输入起始时间（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.todayFinishedOrder.startTime=switchToInt(editForm.todayFinishedOrder.startTime, 'unsigned');switchObjMaxAndMin(editForm.todayFinishedOrder,'startTime','endTime')"
                                    v-model="editForm.todayFinishedOrder.startTime"
                                    placeholder="请输入起始时间"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="结束时间（小时，0-24）"
                                prop="todayFinishedOrder.endTime"
                                :rules="[
                                    { required: true, message: '请输入结束时间（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.todayFinishedOrder.endTime=switchToInt(editForm.todayFinishedOrder.endTime, 'unsigned');switchObjMaxAndMin(editForm.todayFinishedOrder,'startTime','endTime')"
                                    v-model="editForm.todayFinishedOrder.endTime"
                                    placeholder="请输入结束时间"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="全天最小值（件数）"
                                prop="todayFinishedOrder.min"
                                :rules="[
                                    { required: true, message: '请输入全天最小值（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.todayFinishedOrder.min=switchToInt(editForm.todayFinishedOrder.min, 'unsigned');switchObjMaxAndMin(editForm.todayFinishedOrder)"
                                    v-model="editForm.todayFinishedOrder.min"
                                    placeholder="请输入全天最小值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="全天最大值（件数）"
                                prop="todayFinishedOrder.max"
                                :rules="[
                                    { required: true, message: '请输入全天最大值（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.todayFinishedOrder.max=switchToInt(editForm.todayFinishedOrder.max, 'unsigned');switchObjMaxAndMin(editForm.todayFinishedOrder)"
                                    v-model="editForm.todayFinishedOrder.max"
                                    placeholder="请输入全天最大值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form-item>

                <el-form-item class="c-form-item" label="当月累计接单件数">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-gejiachecun/014.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-gejiachecun/014.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        当月累计接单件数 = 最小值和最大值之间的数， 该数值有规律递增
                    </p>
                    <el-form-item class="c-form-item-inner" label="当月累计接单件数（整数）" required>
                        <el-col :span="6">
                            <el-form-item
                                prop="monthOrderClothesNumber.min"
                                :rules="[
                                    { required: true, message: '请输入最小值（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.monthOrderClothesNumber.min=switchToInt(editForm.monthOrderClothesNumber.min, 'unsigned');switchObjMaxAndMin(editForm.monthOrderClothesNumber)"
                                    v-model="editForm.monthOrderClothesNumber.min"
                                    placeholder="请输入最小值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="monthOrderClothesNumber.max"
                                :rules="[
                                    { required: true, message: '请输入最大值（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.monthOrderClothesNumber.max=switchToInt(editForm.monthOrderClothesNumber.max, 'unsigned');switchObjMaxAndMin(editForm.monthOrderClothesNumber)"
                                    v-model="editForm.monthOrderClothesNumber.max"
                                    placeholder="请输入最大值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="交付订单数">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-gejiachecun/015.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-gejiachecun/015.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        当月完成件数 改为 交付订单数；交付订单数 = 最小值和最大值之间的数， 该数值有规律递增；
                    </p>
                    <el-form-item class="c-form-item-inner" label="交付订单数（整数）" required>
                        <el-col :span="6">
                            <el-form-item
                                prop="monthFinishedClothesNumber.min"
                                :rules="[
                                    { required: true, message: '请输入最小值（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.monthFinishedClothesNumber.min=switchToInt(editForm.monthFinishedClothesNumber.min, 'unsigned');switchObjMaxAndMin(editForm.monthFinishedClothesNumber)"
                                    v-model="editForm.monthFinishedClothesNumber.min"
                                    placeholder="请输入最小值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="monthFinishedClothesNumber.max"
                                :rules="[
                                    { required: true, message: '请输入最大值（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.monthFinishedClothesNumber.max=switchToInt(editForm.monthFinishedClothesNumber.max, 'unsigned');switchObjMaxAndMin(editForm.monthFinishedClothesNumber)"
                                    v-model="editForm.monthFinishedClothesNumber.max"
                                    placeholder="请输入最大值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="线上订单">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-gejiachecun/016.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-gejiachecun/016.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        线上订单 = 固定基数基础上，按时间递增最小值和最大值之间的随机数
                    </p>
                    <el-form-item class="c-form-item-inner" label="固定基数（万）"
                        prop="onlineOrderAmount.radix"
                        :rules="[
                            { required: true, message: '请输入固定基数（整数）', trigger: 'blur' }
                        ]"
                    >
                        <el-input
                            @blur="editForm.onlineOrderAmount.radix=switchToInt(editForm.onlineOrderAmount.radix)"
                            class="w"
                            v-model="editForm.onlineOrderAmount.radix"
                            placeholder="请输入固定基数"
                            :disabled="uneditable"
                        ></el-input>
                    </el-form-item>
                    <el-form-item class="c-form-item-inner" label="递增范围（万）" required>
                        <el-col :span="6">
                            <el-form-item
                                prop="onlineOrderAmount.min"
                                :rules="[
                                    { required: true, message: '请输入最小值（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.onlineOrderAmount.min=switchToInt(editForm.onlineOrderAmount.min, 'unsigned');switchObjMaxAndMin(editForm.onlineOrderAmount)"
                                    v-model="editForm.onlineOrderAmount.min"
                                    placeholder="请输入最小值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="onlineOrderAmount.max"
                                :rules="[
                                    { required: true, message: '请输入最大值（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.onlineOrderAmount.max=switchToInt(editForm.onlineOrderAmount.max, 'unsigned');switchObjMaxAndMin(editForm.onlineOrderAmount)"
                                    v-model="editForm.onlineOrderAmount.max"
                                    placeholder="请输入最大值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="线下订单">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-gejiachecun/017.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-gejiachecun/017.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        线下订单 = 固定基数基础上，按时间递增最小值和最大值之间的随机数
                    </p>
                    <el-form-item class="c-form-item-inner" label="固定基数（万）"
                        prop="offlineOrderAmount.radix"
                        :rules="[
                            { required: true, message: '请输入固定基数（整数）', trigger: 'blur' }
                        ]"
                    >
                        <el-input
                            @blur="editForm.offlineOrderAmount.radix=switchToInt(editForm.offlineOrderAmount.radix)"
                            class="w"
                            v-model="editForm.offlineOrderAmount.radix"
                            placeholder="请输入固定基数"
                            :disabled="uneditable"
                        ></el-input>
                    </el-form-item>
                    <el-form-item class="c-form-item-inner" label="递增范围（万）" required>
                        <el-col :span="6">
                            <el-form-item
                                prop="offlineOrderAmount.min"
                                :rules="[
                                    { required: true, message: '请输入最小值（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.offlineOrderAmount.min=switchToInt(editForm.offlineOrderAmount.min, 'unsigned');switchObjMaxAndMin(editForm.offlineOrderAmount)"
                                    v-model="editForm.offlineOrderAmount.min"
                                    placeholder="请输入最小值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="offlineOrderAmount.max"
                                :rules="[
                                    { required: true, message: '请输入最大值（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.offlineOrderAmount.max=switchToInt(editForm.offlineOrderAmount.max, 'unsigned');switchObjMaxAndMin(editForm.offlineOrderAmount)"
                                    v-model="editForm.offlineOrderAmount.max"
                                    placeholder="请输入最大值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="平均订单生产周期">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-gejiachecun/018.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-gejiachecun/018.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        平均订单生产周期 = 最小值和最大值之间的随机数
                    </p>
                    <el-form-item class="c-form-item-inner" label="平均订单生产周期范围" required>
                        <el-col :span="6">
                            <el-form-item
                                prop="averageOrderProductPeriod.min"
                                :rules="[
                                    { required: true, message: '请输入最小值', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.averageOrderProductPeriod.min=switchToFloat(editForm.averageOrderProductPeriod.min, 'unsigned');switchObjMaxAndMin(editForm.averageOrderProductPeriod)"
                                    v-model="editForm.averageOrderProductPeriod.min"
                                    placeholder="请输入最小值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="averageOrderProductPeriod.max"
                                :rules="[
                                    { required: true, message: '请输入最大值', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.averageOrderProductPeriod.max=switchToFloat(editForm.averageOrderProductPeriod.max, 'unsigned');switchObjMaxAndMin(editForm.averageOrderProductPeriod)"
                                    v-model="editForm.averageOrderProductPeriod.max"
                                    placeholder="请输入最大值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="平均打版时间">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-gejiachecun/019.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-gejiachecun/019.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        平均打版时间 = 最小值和最大值之间的随机数
                    </p>
                    <el-form-item class="c-form-item-inner" label="平均打版时间范围" required>
                        <el-col :span="6">
                            <el-form-item
                                prop="averagePlateMakingTime.min"
                                :rules="[
                                    { required: true, message: '请输入最小值', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.averagePlateMakingTime.min=switchToFloat(editForm.averagePlateMakingTime.min, 'unsigned');switchObjMaxAndMin(editForm.averagePlateMakingTime)"
                                    v-model="editForm.averagePlateMakingTime.min"
                                    placeholder="请输入最小值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="averagePlateMakingTime.max"
                                :rules="[
                                    { required: true, message: '请输入最大值', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.averagePlateMakingTime.max=switchToFloat(editForm.averagePlateMakingTime.max, 'unsigned');switchObjMaxAndMin(editForm.averagePlateMakingTime)"
                                    v-model="editForm.averagePlateMakingTime.max"
                                    placeholder="请输入最大值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="资源利用效率">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-gejiachecun/020.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-gejiachecun/020.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        资源利用效率 = 最小值和最大值之间的随机数
                    </p>
                    <el-form-item class="c-form-item-inner" label="资源利用效率范围(小数,0到1之间)" required>
                        <el-col :span="6">
                            <el-form-item
                                prop="resourceUseEfficiency.min"
                                :rules="[
                                    { required: true, message: '请输入最小值', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.resourceUseEfficiency.min=switchToFloat(editForm.resourceUseEfficiency.min, 'unsigned');switchObjMaxAndMin(editForm.resourceUseEfficiency)"
                                    v-model="editForm.resourceUseEfficiency.min"
                                    placeholder="请输入最小值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="resourceUseEfficiency.max"
                                :rules="[
                                    { required: true, message: '请输入最大值', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.resourceUseEfficiency.max=switchToFloat(editForm.resourceUseEfficiency.max, 'unsigned');switchObjMaxAndMin(editForm.resourceUseEfficiency)"
                                    v-model="editForm.resourceUseEfficiency.max"
                                    placeholder="请输入最大值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="缝制单元比率">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-gejiachecun/021.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-gejiachecun/021.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        各类别的缝制单元比率=最大值和最小值之间的随机数
                    </p>
                    <div class="c-row-wrap" v-for="(item, index) in editForm.sewingUnitRatio" :key="item.key">
                        <el-row :gutter="20">
                            <el-col :span="1">
                                <span class="c-sort-num">{{index + 1}}</span> 
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'sewingUnitRatio.' + index + '.name'"
                                    :rules="[
                                        { required: true, message: '请输入缝制类别', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.name" :disabled="uneditable">
                                        <template slot="prepend">缝制类别</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'sewingUnitRatio.' + index + '.min'"
                                    :rules="[
                                        { required: true, message: '请输入最小值（正整数）', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.min" :disabled="uneditable"
                                        @blur="item.min=switchToInt(item.min, 'unsigned');switchMaxAndMin(editForm.sewingUnitRatio, index)"
                                    >
                                        <template slot="prepend">最小值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'sewingUnitRatio.' + index + '.max'"
                                    :rules="[
                                        { required: true, message: '请输入最大值（正整数）', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.max" :disabled="uneditable"
                                        @blur="item.max=switchToInt(item.max, 'unsigned');switchMaxAndMin(editForm.sewingUnitRatio, index)"
                                    >
                                        <template slot="prepend">最大值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" v-if="!uneditable">
                                <i class="el-icon-remove c-remove" 
                                    :class="{'disabled': editForm.sewingUnitRatio.length === 1}" 
                                    :title="editForm.sewingUnitRatio.length > 1 ? '删除该行': '只有一行，不允许删除'"
                                    @click="removeLine('sewingUnitRatio', index)"
                                ></i>
                                <i class="el-icon-circle-plus c-add" title="添加一行"
                                    @click="addLine('sewingUnitRatio', index)"
                                ></i>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item>

                <el-form-item class="c-form-item" label="共享缝制单元">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-gejiachecun/022.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-gejiachecun/022.png">
                        </div>
                    </el-popover>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="总量数值"
                                prop="shareSewingUnit.total"
                                :rules="[
                                    { required: true, message: '请输入总量数值（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.shareSewingUnit.total=switchToInt(editForm.shareSewingUnit.total, 'unsigned')"
                                    v-model="editForm.shareSewingUnit.total"
                                    placeholder="请输入总量数值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="共享数值"
                                prop="shareSewingUnit.share"
                                :rules="[
                                    { required: true, message: '请输入共享数值（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.shareSewingUnit.share=switchToInt(editForm.shareSewingUnit.share, 'unsigned')"
                                    v-model="editForm.shareSewingUnit.share"
                                    placeholder="请输入共享数值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form-item>

                <el-form-item class="c-form-item" label="共享裁剪">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-gejiachecun/023.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-gejiachecun/023.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        共享裁剪 = 最小值和最大值之间的随机数
                    </p>
                    <el-form-item class="c-form-item-inner" label="共享裁剪范围(小数,0到1之间)" required>
                        <el-col :span="6">
                            <el-form-item
                                prop="shareTailor.min"
                                :rules="[
                                    { required: true, message: '请输入最小值', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.shareTailor.min=switchToFloat(editForm.shareTailor.min, 'unsigned');switchObjMaxAndMin(editForm.shareTailor)"
                                    v-model="editForm.shareTailor.min"
                                    placeholder="请输入最小值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="shareTailor.max"
                                :rules="[
                                    { required: true, message: '请输入最大值', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.shareTailor.max=switchToFloat(editForm.shareTailor.max, 'unsigned');switchObjMaxAndMin(editForm.shareTailor)"
                                    v-model="editForm.shareTailor.max"
                                    placeholder="请输入最大值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="共享打版">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-gejiachecun/024.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-gejiachecun/024.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        共享打版 = 最小值和最大值之间的随机数
                    </p>
                    <el-form-item class="c-form-item-inner" label="共享打版范围(小数,0到1之间)" required>
                        <el-col :span="6">
                            <el-form-item
                                prop="sharePlateMaking.min"
                                :rules="[
                                    { required: true, message: '请输入最小值', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.sharePlateMaking.min=switchToFloat(editForm.sharePlateMaking.min, 'unsigned');switchObjMaxAndMin(editForm.sharePlateMaking)"
                                    v-model="editForm.sharePlateMaking.min"
                                    placeholder="请输入最小值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="sharePlateMaking.max"
                                :rules="[
                                    { required: true, message: '请输入最大值', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.sharePlateMaking.max=switchToFloat(editForm.sharePlateMaking.max, 'unsigned');switchObjMaxAndMin(editForm.sharePlateMaking)"
                                    v-model="editForm.sharePlateMaking.max"
                                    placeholder="请输入最大值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="共享后道">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-gejiachecun/026.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-gejiachecun/026.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        共享后道 = 最小值和最大值之间的随机数
                    </p>
                    <el-form-item class="c-form-item-inner" label="共享后道范围(小数,0到1之间)" required>
                        <el-col :span="6">
                            <el-form-item
                                prop="shareBackEnd.min"
                                :rules="[
                                    { required: true, message: '请输入最小值', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.shareBackEnd.min=switchToFloat(editForm.shareBackEnd.min, 'unsigned');switchObjMaxAndMin(editForm.shareBackEnd)"
                                    v-model="editForm.shareBackEnd.min"
                                    placeholder="请输入最小值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="shareBackEnd.max"
                                :rules="[
                                    { required: true, message: '请输入最大值', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.shareBackEnd.max=switchToFloat(editForm.shareBackEnd.max, 'unsigned');switchObjMaxAndMin(editForm.shareBackEnd)"
                                    v-model="editForm.shareBackEnd.max"
                                    placeholder="请输入最大值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="共享仓储">
                    <!-- <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-gejiachecun/026.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-gejiachecun/026.png">
                        </div>
                    </el-popover> -->
                    <p class="info">
                        共享仓储 = 最小值和最大值之间的随机数
                    </p>
                    <el-form-item class="c-form-item-inner" label="共享后道范围(小数,0到1之间)" required>
                        <el-col :span="6">
                            <el-form-item
                                prop="shareStorage.min"
                                :rules="[
                                    { required: true, message: '请输入最小值', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.shareStorage.min=switchToFloat(editForm.shareStorage.min, 'unsigned');switchObjMaxAndMin(editForm.shareStorage)"
                                    v-model="editForm.shareStorage.min"
                                    placeholder="请输入最小值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="shareStorage.max"
                                :rules="[
                                    { required: true, message: '请输入最大值', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.shareStorage.max=switchToFloat(editForm.shareStorage.max, 'unsigned');switchObjMaxAndMin(editForm.shareStorage)"
                                    v-model="editForm.shareStorage.max"
                                    placeholder="请输入最大值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="生产中数量">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-gejiachecun/027.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-gejiachecun/027.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        生产中数量 = 当月成衣加工件数 * (最小值和最大值之间的随机数)
                    </p>
                    <el-form-item class="c-form-item-inner" label="生产中数量占比范围(小数,0到1之间)" required>
                        <el-col :span="6">
                            <el-form-item
                                prop="inProductionNumbe.min"
                                :rules="[
                                    { required: true, message: '请输入最小值', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.inProductionNumbe.min=switchToFloat(editForm.inProductionNumbe.min, 'unsigned');switchObjMaxAndMin(editForm.inProductionNumbe)"
                                    v-model="editForm.inProductionNumbe.min"
                                    placeholder="请输入最小值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="inProductionNumbe.max"
                                :rules="[
                                    { required: true, message: '请输入最大值', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.inProductionNumbe.max=switchToFloat(editForm.inProductionNumbe.max, 'unsigned');switchObjMaxAndMin(editForm.inProductionNumbe)"
                                    v-model="editForm.inProductionNumbe.max"
                                    placeholder="请输入最大值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="各品类累计生产量">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-gejiachecun/029.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-gejiachecun/029.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        各品类累计生产量=最大值(整数)和最小值(整数)之间的随机数
                    </p>
                    <div class="c-row-wrap" v-for="(item, index) in editForm.productionEachCategory" :key="item.key">
                        <el-row :gutter="20">
                            <el-col :span="1">
                                <span class="c-sort-num">{{index + 1}}</span> 
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'productionEachCategory.' + index + '.name'"
                                    :rules="[
                                        { required: true, message: '请输入生产品类', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.name" :disabled="uneditable">
                                        <template slot="prepend">生产品类</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'productionEachCategory.' + index + '.min'"
                                    :rules="[
                                        { required: true, message: '请输入最小值（正整数）', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.min" :disabled="uneditable"
                                        @blur="item.min=switchToInt(item.min, 'unsigned');switchMaxAndMin(editForm.productionEachCategory, index)"
                                    >
                                        <template slot="prepend">最小值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'productionEachCategory.' + index + '.max'"
                                    :rules="[
                                        { required: true, message: '请输入最大值（正整数）', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.max" :disabled="uneditable"
                                        @blur="item.max=switchToInt(item.max, 'unsigned');switchMaxAndMin(editForm.productionEachCategory, index)"
                                    >
                                        <template slot="prepend">最大值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" v-if="!uneditable">
                                <i class="el-icon-remove c-remove" 
                                    :class="{'disabled': editForm.productionEachCategory.length === 1}" 
                                    :title="editForm.productionEachCategory.length > 1 ? '删除该行': '只有一行，不允许删除'"
                                    @click="removeLine('productionEachCategory', index)"
                                ></i>
                                <i class="el-icon-circle-plus c-add" title="添加一行"
                                    @click="addLine('productionEachCategory', index)"
                                ></i>
                            </el-col>
                        </el-row>
                    </div>
                    <p class="info" style="margin-top: 16px">
                        单独展示的三个生产品类（件数）
                    </p>
                    <div class="c-row-wrap">
                        <el-row :gutter="20">
                            <el-col :span="1">
                                <span class="c-sort-num">A</span> 
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    prop="singleCategoryShowA.name"
                                    :rules="[
                                        { required: true, message: '请输入生产品类', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="editForm.singleCategoryShowA.name" :disabled="uneditable">
                                        <template slot="prepend">生产品类</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    prop="singleCategoryShowA.min"
                                    :rules="[
                                        { required: true, message: '请输入最小值', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="editForm.singleCategoryShowA.min" :disabled="uneditable"
                                        @blur="editForm.singleCategoryShowA.min=switchToInt(editForm.singleCategoryShowA.min, 'unsigned');switchObjMaxAndMin(editForm.singleCategoryShowA)"
                                    >
                                        <template slot="prepend">最小值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    prop="singleCategoryShowA.max"
                                    :rules="[
                                        { required: true, message: '请输入最大值', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="editForm.singleCategoryShowA.max" :disabled="uneditable"
                                        @blur="editForm.singleCategoryShowA.max=switchToInt(editForm.singleCategoryShowA.max, 'unsigned');switchObjMaxAndMin(editForm.singleCategoryShowA)"
                                    >
                                        <template slot="prepend">最大值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="c-row-wrap">
                        <el-row :gutter="20">
                            <el-col :span="1">
                                <span class="c-sort-num">B</span> 
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    prop="singleCategoryShowB.name"
                                    :rules="[
                                        { required: true, message: '请输入生产品类', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="editForm.singleCategoryShowB.name" :disabled="uneditable">
                                        <template slot="prepend">生产品类</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    prop="singleCategoryShowB.min"
                                    :rules="[
                                        { required: true, message: '请输入最小值', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="editForm.singleCategoryShowB.min" :disabled="uneditable"
                                        @blur="editForm.singleCategoryShowB.min=switchToInt(editForm.singleCategoryShowB.min, 'unsigned');switchObjMaxAndMin(editForm.singleCategoryShowB)"
                                    >
                                        <template slot="prepend">最小值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    prop="singleCategoryShowB.max"
                                    :rules="[
                                        { required: true, message: '请输入最大值', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="editForm.singleCategoryShowB.max" :disabled="uneditable"
                                        @blur="editForm.singleCategoryShowB.max=switchToInt(editForm.singleCategoryShowB.max, 'unsigned');switchObjMaxAndMin(editForm.singleCategoryShowB)"
                                    >
                                        <template slot="prepend">最大值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="c-row-wrap">
                        <el-row :gutter="20">
                            <el-col :span="1">
                                <span class="c-sort-num">C</span> 
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    prop="singleCategoryShowC.name"
                                    :rules="[
                                        { required: true, message: '请输入生产品类', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="editForm.singleCategoryShowC.name" :disabled="uneditable">
                                        <template slot="prepend">生产品类</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    prop="singleCategoryShowC.min"
                                    :rules="[
                                        { required: true, message: '请输入最小值', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="editForm.singleCategoryShowC.min" :disabled="uneditable"
                                        @blur="editForm.singleCategoryShowC.min=switchToInt(editForm.singleCategoryShowC.min, 'unsigned');switchObjMaxAndMin(editForm.singleCategoryShowC)"
                                    >
                                        <template slot="prepend">最小值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    prop="singleCategoryShowC.max"
                                    :rules="[
                                        { required: true, message: '请输入最大值', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="editForm.singleCategoryShowC.max" :disabled="uneditable"
                                        @blur="editForm.singleCategoryShowC.max=switchToInt(editForm.singleCategoryShowC.max, 'unsigned');switchObjMaxAndMin(editForm.singleCategoryShowC)"
                                    >
                                        <template slot="prepend">最大值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item>

                <el-form-item class="c-form-item" label="生产类型排行">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-gejiachecun/030.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-gejiachecun/030.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        各生产类型的数量=最大值(整数)和最小值(整数)之间的随机数
                    </p>
                    <div class="c-row-wrap" v-for="(item, index) in editForm.productCategoryRank" :key="item.key">
                        <el-row :gutter="20">
                            <el-col :span="1">
                                <span class="c-sort-num">{{index + 1}}</span> 
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'productCategoryRank.' + index + '.name'"
                                    :rules="[
                                        { required: true, message: '请输入生产类型', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.name" :disabled="uneditable">
                                        <template slot="prepend">生产类型</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'productCategoryRank.' + index + '.min'"
                                    :rules="[
                                        { required: true, message: '请输入最小值（正整数）', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.min" :disabled="uneditable"
                                        @blur="item.min=switchToInt(item.min, 'unsigned');switchMaxAndMin(editForm.productCategoryRank, index)"
                                    >
                                        <template slot="prepend">最小值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'productCategoryRank.' + index + '.max'"
                                    :rules="[
                                        { required: true, message: '请输入最大值（正整数）', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.max" :disabled="uneditable"
                                        @blur="item.max=switchToInt(item.max, 'unsigned');switchMaxAndMin(editForm.productCategoryRank, index)"
                                    >
                                        <template slot="prepend">最大值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" v-if="!uneditable">
                                <i class="el-icon-remove c-remove" 
                                    :class="{'disabled': editForm.productCategoryRank.length === 1}" 
                                    :title="editForm.productCategoryRank.length > 1 ? '删除该行': '只有一行，不允许删除'"
                                    @click="removeLine('productCategoryRank', index)"
                                ></i>
                                <i class="el-icon-circle-plus c-add" title="添加一行"
                                    @click="addLine('productCategoryRank', index)"
                                ></i>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item>

                <el-form-item class="c-form-item" label="生产订单列表">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-gejiachecun/031.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-gejiachecun/031.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        订单数据根据葛家车企业在衣加加的真实订单数据生成, 请输入葛家车园区企业注册手机号
                    </p>
                    <div class="c-row-wrap" v-for="(item, index) in editForm.productionOrderList.list" :key="item.key">
                        <el-row :gutter="20">
                            <el-col :span="1">
                                <span class="c-sort-num">{{index + 1}}</span> 
                            </el-col>
                            <el-col :span="10">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'productionOrderList.list.' + index + '.cellphone'"
                                    :rules="[
                                        { required: true, message: '请输入手机号', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.cellphone" :disabled="uneditable">
                                        <template slot="prepend">手机号</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" v-if="!uneditable">
                                <i class="el-icon-remove c-remove" 
                                    :class="{'disabled': editForm.productionOrderList.list.length === 1}" 
                                    :title="editForm.productionOrderList.list.length > 1 ? '删除该行': '只有一行，不允许删除'"
                                    @click="removeLine('productionOrderList.list', index)"
                                ></i>
                                <i class="el-icon-circle-plus c-add" title="添加一行"
                                    @click="addLine('productionOrderList.list', index)"
                                ></i>
                            </el-col>
                        </el-row>
                    </div>
                    <el-form-item class="c-form-item-inner" label="输出行数"
                        prop="productionOrderList.lineNumber"
                        :rules="[
                            { required: true, message: '请输入输出行数（正整数）', trigger: 'blur' }
                        ]"
                    >
                        <el-input
                            @blur="editForm.productionOrderList.lineNumber=switchToInt(editForm.productionOrderList.lineNumber, 'unsigned')"
                            class="w"
                            v-model="editForm.productionOrderList.lineNumber"
                            placeholder="请输入输出行数"
                            :disabled="uneditable"
                        ></el-input>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="园区各企业及年产值">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-gejiachecun/032.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-gejiachecun/032.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        园区企业对应产值=在全年最小值与全年最大值之间按自然日递增
                    </p>
                    <div class="c-row-wrap" v-for="(item, index) in editForm.parkCompanyYearValue" :key="item.key">
                        <el-row :gutter="20">
                            <el-col :span="1">
                                <span class="c-sort-num">{{index + 1}}</span> 
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'parkCompanyYearValue.' + index + '.name'"
                                    :rules="[
                                        { required: true, message: '请输入企业名称', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.name" :disabled="uneditable">
                                        <template slot="prepend">企业名称</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'parkCompanyYearValue.' + index + '.min'"
                                    :rules="[
                                        { required: true, message: '请输入最小值（正整数）', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.min" :disabled="uneditable"
                                        @blur="item.min=switchToInt(item.min, 'unsigned');switchMaxAndMin(editForm.parkCompanyYearValue, index)"
                                    >
                                        <template slot="prepend">最小值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'parkCompanyYearValue.' + index + '.max'"
                                    :rules="[
                                        { required: true, message: '请输入最大值（正整数）', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.max" :disabled="uneditable"
                                        @blur="item.max=switchToInt(item.max, 'unsigned');switchMaxAndMin(editForm.parkCompanyYearValue, index)"
                                    >
                                        <template slot="prepend">最大值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" v-if="!uneditable">
                                <i class="el-icon-remove c-remove" 
                                    :class="{'disabled': editForm.parkCompanyYearValue.length === 1}" 
                                    :title="editForm.parkCompanyYearValue.length > 1 ? '删除该行': '只有一行，不允许删除'"
                                    @click="removeLine('parkCompanyYearValue', index)"
                                ></i>
                                <i class="el-icon-circle-plus c-add" title="添加一行"
                                    @click="addLine('parkCompanyYearValue', index)"
                                ></i>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item>

            </el-form>
            <div class="bottom-btns-wrap" v-if="!uneditable">
                <el-button class="btn-cancel" @click="cancelEdit">取消</el-button>
                <el-button class="btn-large" type="primary" @click="submitHandle">提交</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import {ajaxDatav} from '../../common/request_datav.js'
export default {
    data() {
        return {
            uneditable: true,
            editForm: {
                // 在职工人数
                factoryStaffNumer: {
                    min: '', // 配置最小值
                    max: ''  // 配置最大值
                },

                // 出勤人数
                attendanceStaffNumber: {
                    min: '', // 配置最小值
                    max: ''  // 配置最大值
                },

                // 工厂面积
                factoryArea: {
                    radix: '' // 配置数据
                },

                // 工厂数量
                factoryNumber: {
                    radix: '' // 配置数据
                },

                // 设备数量
                equipmentNumber: {
                    radix: '' // 配置数据
                },

                // 共享设备数量
                shareEquipmentNumber: {
                    radix: '' // 配置数据
                },

                // 当月面料供应单量
                monthFabricSupply: {
                    number: '', // 数量（单）
                    money: '',  // 金额（元）
                },

                // 当月辅料供应单量
                monthAccessoriesSupply: {
                    number: '', // 数量（单）
                    money: '',  // 金额（元）
                },

                // 外部工厂对接数
                externalFactoryNumber: {
                    radix: '', // 固定基数
                    min: '', // 配置最小值
                    max: '', // 配置最大值                    
                },

                // 达标免租空间
                standardsFreeSpace: {
                    radix: '', // 配置数据
                },
                
                // 累计免租额
                totalFreeAmount: {
                    radix: '', // 附加数据
                },

                // 当月成衣加工件数
                monthClothesProductNumber: {
                    min: '', // 最小值
                    max: '', // 最大值
                },

                // 今日完成订单数
                todayFinishedOrder: {
                    startTime: '', // 起始时间 (时) 24小时制
                    endTime: '',   // 结束时间
                    min: '',   // 最小值
                    max: '',   // 最大值 
                },

                // 当月累计接单件数
                monthOrderClothesNumber: {
                    min: '', // 最小值
                    max: ''  // 最大值
                },

                // 当月完成件数 -> 交付订单数
                monthFinishedClothesNumber: {
                    min: '', // 最小值
                    max: '', // 最大值
                },

                // 线上订单
                onlineOrderAmount: {
                    radix: '', // 固定基数
                    min: '', // 配置最小值
                    max: '', // 配置最大值
                },

                // 线下订单
                offlineOrderAmount: {
                    radix: '', // 固定基数
                    min: '', // 配置最小值
                    max: '', // 配置最大值
                },

                // 平均订单生产周期
                averageOrderProductPeriod: {
                    min: '', // 最小值
                    max: '', // 最大值
                },

                // 平均打版时间
                averagePlateMakingTime: {
                    min: '', // 最小值
                    max: '', // 最大值
                },

                // 资源利用效率
                resourceUseEfficiency: {
                    min: '', // 最小值
                    max: '', // 最大值
                },

                // 缝制单元比率
                sewingUnitRatio: [
                    {
                        key: 1,
                        name: '', // 缝制类别名
                        min: '', // 最小值
                        max: '', // 最大值
                    }
                ],

                // 共享缝制单元
                shareSewingUnit: {
                    total: '', // 总量数值
                    share: ''  // 共享数值
                },

                // 共享裁剪
                shareTailor: {
                    min: '',  // 最小值
                    max: ''   // 最大值
                },

                // 共享打版
                sharePlateMaking: {
                    min: '',  // 最小值
                    max: ''   // 最大值
                },

                // 共享熨烫，共享后道合并 => 共享后道
                shareBackEnd: {
                    min: '',    // 最小值
                    max: '',
                },

                // 共享仓储
                shareStorage: {
                    min: '',    // 最小值
                    max: '',
                },

                // 生产中数量
                inProductionNumbe: {
                    min: '',    // 最小值
                    max: ''     // 最大值
                },

                // 成品数量 - 无

                // 各品类累计生产量
                productionEachCategory: [
                    {
                        key: 1,
                        name: '', // 生产品类
                        min: '',  // 最小值
                        max: '',  // 最大值
                    }
                ],
                // T恤
                singleCategoryShowA: {
                    name: '', // 品类名称
                    min: '',
                    max: '',
                },
                // 外套
                singleCategoryShowB: {
                    name: '', // 品类名称
                    min: '',
                    max: '',
                },
                // 上衣
                singleCategoryShowC: {
                    name: '', // 品类名称
                    min: '',
                    max: '',
                },

                // 生产类型排行
                productCategoryRank: [
                    {
                        key: 1,
                        name: '', // 生产类型名
                        min: '', // 配置最小值
                        max: '', // 配置最大值
                    }
                ],

                // 生产订单列表
                productionOrderList: {
                    list: [
                        {
                            key: 1,
                            cellphone: '' // 注册手机号
                        }
                    ],
                    lineNumber: ''  // 输出行数
                },

                // 园区各企业及年产值
                parkCompanyYearValue: [
                    {
                        key: 1,
                        name: '', // 企业名称
                        min: '',  // 配置最小值
                        max: '',  // 配置最大值
                    }
                ]
            }
        }
    },
    created() {
        this.getData();
    },
    methods: {
        // 编辑操作
        editHandle() {
            this.uneditable = false
        },
        // 取消编辑
        cancelEdit() {
            this.$confirm('确认取消编辑吗?', '提示', {
                confirmButtonText: '取消编辑',
                cancelButtonText: '继续编辑',
                type: 'warning'
            }).then(() => {
                this.uneditable = true
                this.$refs['editForm'].clearValidate()
                this.getData();
            })
        },
        // 跳转外部链接
        linkToDataV() {
            window.open('https://datav.aliyuncs.com/share/74e0b4df3fd82f5980485a4bafd753df')
        },
        // 立即生效
        takeEffectAtOnce() {
            this.$confirm('数据配置默认第二天零点生效，若需立即生效，可使用本功能。本功能将立即刷新数据到大屏，有可能造成当日数据前后不一致。请谨慎使用。', '提示', {
                confirmButtonText: '立即生效',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                console.log('立即生效')
                ajaxDatav.post('/data-statistics/refreshByNumber', {
                    number: 5
                }).then(res => {
                    if (res.code == 200) {
                        this.$message.success('提交成功，配置的数据会立即生效到大屏！');
                    } else {
                        this.$message.error(res.msg)
                    }
                }).catch(e => {
                    console.error(e)
                })
            }).catch(err=> {
                console.log(err)
            })
        },
        // 回到顶部
        toPageTop() {
            document.querySelector('#mainBox').scrollTop = 0;
        },
        // 删除一行
        removeLine(key, index) {
            if (key.indexOf('.')>=0) {
                let keys = key.split('.');
                if (keys.length == 2) {
                    let length = this.editForm[keys[0]][keys[1]].length
                    if (length <= 1) return
                    this.editForm[keys[0]][keys[1]].splice(index, 1)
                } else {
                    console.warn('Please improve this feature.')
                }
            } else {
                let length = this.editForm[key].length
                if (length <= 1) return
                this.editForm[key].splice(index, 1)
            }
        },
        // 添加一行
        addLine(key, index) {
            let d = Date.now()
            let item
            if (key == 'plantCapacityRank') {
                item = {
                    key: d,
                    name: '',
                    radix: ''
                }
            }
            if (key == 'provinceOrder') {
                item = {
                    key: d,
                    name: '',
                    rate: '',
                    radix: ''
                }
            }
            if (key == 'sewingUnitRatio' || key == 'productionEachCategory' || key == 'parkCompanyYearValue' || key == 'productCategoryRank') {
                item = {
                    key: d,
                    name: '',
                    min: '',
                    max: ''
                }
            }
            if (key == 'productionOrderList.list') {
                item = {
                    key: d,
                    cellphone: ''
                }
            }

            if (key.indexOf('.')>=0) {
                let keys = key.split('.');
                if(keys.length == 2) {
                    this.editForm[keys[0]][keys[1]].splice(index+1, 0, item)
                } else {
                    console.warn('Please improve this feature.')
                }
            } else {
                this.editForm[key].splice(index+1, 0, item)
            }
            
        },
        // 转化为整数
        switchToInt(value, type) {
            let v = parseInt(value)
            if (isNaN(v)) return ''
            return type === 'unsigned' ? Math.abs(v) : v
        },
        // 转化为浮点数
        switchToFloat(value, type) {
            let v = parseFloat(value)
            if (isNaN(v)) return ''
            return type === 'unsigned' ? Math.abs(v) : v
        },
        // 获取数据
        getData() {
            ajaxDatav.get('/data-setting/getByNumber', {
                number: 5
            }).then(res => {
                console.log(res)
                if (res.code == 200) {
                    if (res.data && res.data.content) {
                        try {
                            let content = JSON.parse(res.data.content);
                            this.editForm = {
                                ...this.editForm,
                                ...content
                            }
                        } catch (error) {
                            console.log(error)
                        }
                    }
                } else {
                    this.$message.error(res.msg)
                }
            }).catch(e => {
                console.error(e);
            })
        },
        // 提交表单
        submitHandle() {
            console.log('submit');
            // console.log(this.editForm);
            // console.log(JSON.stringify(this.editForm));

            this.$refs['editForm'].validate((valid) => {
                if (valid) {
                    const loading = this.$loading({
                        lock: true,
                        text: '正在提交数据...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });

                    ajaxDatav.post('/data-setting/save', {
                        content: JSON.stringify(this.editForm),
                        number: 5
                    }).then(res => {
                        if (res.code == 200) {
                            this.$message.success('提交成功');
                            this.uneditable = true
                            this.getData();
                        } else {
                            this.$message.error(res.msg)
                        }
                    }).catch(e => {
                        console.error(e)
                    }).finally(() => {
                        loading.close();
                    })
                } else {
                    this.$message.error('校验不通过，请检查表单')
                }
            })
        },
        // 自动切换对象中最大值和最小值
        switchObjMaxAndMin(obj, min='min', max='max') {
            if (obj[min] === '' || obj[max] === '') return
            if (obj[min] > obj[max]) {
                let middle = obj[min]
                obj[min] = obj[max]
                obj[max] = middle
            }
        },
        // 自动切换列表中最大值和最小值
        switchMaxAndMin(list, index, min='min', max='max') {
            if (list[index][min] === '' || list[index][max] === '') return
            if (list[index][min] > list[index][max]) {
                let middle = list[index][min]
                list[index][min] = list[index][max]
                list[index][max] = middle
            }
        }
    }
}
</script>

<style scoped lang="scss">
.page-wrapper {
    background: #fff;
    padding-bottom: 80px;
    min-height: 100px;
    .tit {
        margin: 0;
        padding: 24px;
        font-size: 20px;
        color: #111;
        font-weight: normal;
    }
    .top-btns {
        position: fixed;
        top: 40%;
        right: 32px;
        z-index: 100;
        .r-btn {
            margin-top: 6px;
        }
    } 
    .datav-form-wrapper {
        width: 900px;
        padding: 0 24px;
        .w {
            width: 400px;
        }
        .w2 {
            width: 200px;
        }
        .info {
            font-size: 13px;
            color: #888;
            line-height: 1.5;
        }
    }
    .c-row-wrap {
        padding: 8px 0;
    }
    .c-sort-num {
        margin-top: 12px;
        display: block;
        width: 20px;
        height: 20px;
        border: 1px solid #999;
        line-height: 20px;
        text-align: center;
        color: #999;
        font-size: 12px;
        border-radius: 50%;
    }
    .c-remove {
        margin-right: 4px;
        cursor: pointer;
        font-size: 16px;
        &.disabled {
            color: #ccc;
            cursor: no-drop;
        }
    }
    .c-add {
        font-size: 16px;
        cursor: pointer;
    }
    .bottom-btns-wrap {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        box-sizing: border-box;
        padding: 20px 0 20px 0px;
        text-align: center;
        z-index: 1;
        background: #fff;
        box-shadow: 0 -2px 10px #ccc;
        .btn-large {
            padding: 14px 120px;
        }
        .btn-cancel {
            padding-top: 14px;
            padding-bottom: 14px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/datav/park-gejiachecun.vue